import Immutable from 'immutable';
import config from '../../config';

export const defaultState = Immutable.Map({
  loaded: false,
  loading: false,
  data: null,
  error: false,
  validationErrors: Immutable.Map(),
});

export function formatValidationErrors(error) {
  const errors = {};

  if (!error || !error.validationErrors) {
    return Immutable.fromJS(errors);
  }

  const validationMessages = config.validationMessages || {};

  error.validationErrors.forEach(validationError => {
    if (!errors[validationError.key]) {
      errors[validationError.key] = [];
    }
    errors[validationError.key].push(validationMessages[validationError.type] || validationError.message);
  });

  return Immutable.fromJS(errors);
}

export function formatSubscriptionErrors(error) {
  let field, message;
  let formattedError = {};
  switch (error.message) {
    case 'email_in_use':
      field = 'email';
      message = 'Email in use.';
      break;
    case 'card_declined':
      field = 'number';
      message = 'Your card was declined.';
      break;
    case 'invalid_coupon':
      field = '_error';
      message = 'That promo code is not valid.';
      break;
    case 'price_changed':
      field = '_error';
      message = 'The Gift Subscription price has been updated. Please refresh the page.';
      break;
    default:
      field = '_error';
      message = 'An unknown error occurred.';
      break;
  }
  formattedError[field] = message;
  return Immutable.fromJS(formattedError);
}

export default actionTypePrefix => {
  return function(state = defaultState, action) {
    switch (action.type) {
      case `${actionTypePrefix}_REQUEST`:
        return state.merge({
          loading: true,
          loaded: false,
          data: null,
          validationErrors: Immutable.Map(),
        });
      case `${actionTypePrefix}_SUCCESS`:
        return state.merge({
          loading: false,
          loaded: true,
          data: Immutable.fromJS(action.json),
          validationErrors: Immutable.Map(),
          error: false,
        });
      case `${actionTypePrefix}_FAILURE`:
        return state.merge({
          loading: false,
          loaded: false,
          data: null,
          validationErrors: formatValidationErrors(action.json),
          error: !!action.json && !!action.json.validationErrors ? null : Immutable.fromJS(action.json),
        });
      case `${actionTypePrefix}_RESET`:
        return defaultState;
      default:
        break;
    }

    return state;
  };
};



// WEBPACK FOOTER //
// ./src/common/utils/getApiReducer.js